import _ from 'underscore';
import $ from 'jquery';
import * as config from '../../../home24/core/config';

/**
 * cart manager
 * single place to add products to cart
 */
export default function CartManager() {
  this._sku = [];
  this._quantity = 1;
  this._assemblyServiceSku = '';

  this._onLoadCallback = function() {};
  this._onSuccessCallback = function() {};
  this._onErrorCallback = function() {};
}

CartManager.prototype = {
  _ajaxUrl: config.getBaseUrl() + '/checkout/cart/add',

  setSku: function(sku) {
    if (_.isArray(sku)) {
      this._sku = sku;
    } else {
      this._sku.push(sku);
    }

    return this;
  },

  setQuantity: function(quantity) {
    this._quantity = parseInt(quantity, 10);

    return this;
  },

  setAssemblyService: function(assemblyServiceSku) {
    this._assemblyServiceSku = assemblyServiceSku;

    return this;
  },

  onLoad: function(onLoadCallback) {
    if (typeof onLoadCallback === 'function') {
      this._onLoadCallback = onLoadCallback;
    }

    return this;
  },

  onSuccess: function(onSuccessCallback) {
    if (typeof onSuccessCallback === 'function') {
      this._onSuccessCallback = onSuccessCallback;
    }

    return this;
  },

  onError: function(onErrorCallback) {
    if (typeof onErrorCallback === 'function') {
      this._onErrorCallback = onErrorCallback;
    }

    return this;
  },

  run: function() {
    var that = this;
    var data;

    that._onLoadCallback();

    data = that._prepareData();

    $.ajax({
      type: 'POST',
      url: this._ajaxUrl,
      data,
      success: function(d) {
        that._onSuccessCallback(d);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        that._onErrorCallback(textStatus, errorThrown);
      }
    });

    return this;
  },

  _prepareData: function() {
    var data = {
      sku: this._sku,
      qty: this._quantity
    };

    if (this._assemblyServiceSku !== '') {
      data['options[assembly_service]'] = this._assemblyServiceSku;
    }

    return data;
  }
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/addToCart/cartManager.js
 **/